import React from 'react';
import Mathcca6to82024 from 'views/Mathcca6to82024';
const MathClubPage = () => {
  return <Mathcca6to82024/>;
};

export default MathClubPage;

